import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
export function ProviderNetwork() {
  return <section id="providers" className="py-24 relative overflow-hidden" data-id="element-270">
      {/* Decorative elements */}
      <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-[#BBDDFF]/10 blur-3xl" data-id="element-271"></div>
      <div className="absolute -bottom-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-[#C85A15]/5 blur-3xl" data-id="element-272"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-273">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-274">
          <div className="order-2 lg:order-1 relative" data-id="element-275">
            <div className="absolute inset-0 bg-gradient-to-br from-[#BBDDFF]/20 to-[#C85A15]/20 rounded-3xl blur-xl" data-id="element-276"></div>
            <div className="relative bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-277">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iUiJXeWD12CqeEC4UKiw8g/provider_tracking.png" alt="Provider Dashboard - Patient Health Tracking" className="w-full h-auto" data-id="element-278" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-279">
            <div className="inline-block mb-4 px-4 py-1 rounded-full bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 backdrop-blur-sm border border-white/10" data-id="element-280">
              <span className="text-sm font-medium" data-id="element-281">
                For Healthcare Providers
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-282">
              <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-283">
                Join our exclusive provider network
              </span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-284">
              Partner with JoinOmu to focus on what matters most - delivering
              exceptional patient care. Our platform handles the administrative
              burden of finding and communicating with patients and goes beyond
              charting to give you an unparalleled view into your patients
              treatment and progress.
            </p>
            <div className="space-y-4 mb-8" data-id="element-285">
              <div className="flex items-start" data-id="element-286">
                <CheckCircle className="text-[#C85A15] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-287" />
                <p className="text-gray-700 dark:text-gray-200" data-id="element-288">
                  Practice on your schedule with flexible hours
                </p>
              </div>
              <div className="flex items-start" data-id="element-289">
                <CheckCircle className="text-[#C85A15] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-290" />
                <p className="text-gray-700 dark:text-gray-200" data-id="element-291">
                  Dedicated patient base without network overloading
                </p>
              </div>
              <div className="flex items-start" data-id="element-292">
                <CheckCircle className="text-[#C85A15] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-293" />
                <p className="text-gray-700 dark:text-gray-200" data-id="element-294">
                  Streamlined administrative processes
                </p>
              </div>
              <div className="flex items-start" data-id="element-295">
                <CheckCircle className="text-[#C85A15] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-296" />
                <p className="text-gray-700 dark:text-gray-200" data-id="element-297">
                  Competitive compensation and growth opportunities
                </p>
              </div>
            </div>
            <a href="https://www.indeed.com/viewjob?jk=da22fcc0bd6a38ab&from=shareddesktop_copy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] text-white font-medium py-3 px-6 rounded-full hover:shadow-lg transition-all group" data-id="element-298">
              Join our provider network
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} data-id="element-299" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}